import React from 'react';
import { Section } from './ui/Section';
import { CheckIcon, MoonIcon } from 'lucide-react';
export function ProductReveal() {
  return <Section alternate className="relative overflow-hidden" data-id="element-174">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2 pointer-events-none" data-id="element-175" />

      <div className="text-center mb-10" data-id="element-176">
        <div className="inline-flex items-center justify-center p-3 bg-amber-500/10 rounded-full mb-4" data-id="element-177">
          <MoonIcon className="w-8 h-8 text-amber-500" data-id="element-178" />
        </div>
        <h2 className="text-3xl md:text-5xl font-serif text-cream-50 mb-4" data-id="element-179">
          Presentando <br data-id="element-180" />
          <span className="text-amber-500" data-id="element-181">"3AM otra vez"</span>
        </h2>
        <p className="text-lg text-cream-100 opacity-80 uppercase tracking-widest text-sm" data-id="element-182">
          Kit Anti-Despertar Nocturno
        </p>
      </div>

      <div className="bg-warm-900 p-8 rounded-2xl border border-warm-700 shadow-2xl" data-id="element-183">
        <p className="text-lg mb-8 text-center" data-id="element-184">
          Este kit es para mujeres 65+ que se despiertan con calor/sudor y luego
          se quedan atrapadas en la mente.
        </p>

        <h3 className="text-xl font-serif text-amber-500 mb-6 border-b border-warm-700 pb-2" data-id="element-185">
          Lo que incluye:
        </h3>

        <ul className="space-y-4" data-id="element-186">
          {['El protocolo BVV (7 minutos)', 'Tarjetas 3AM listas para imprimir', 'Checklist de preparación nocturna (2 minutos)', 'Mini-enfriamiento seguro (60–90 segundos)', 'Ruta al baño "sin despertar del todo"', 'Plan de 7 días para instalar el hábito'].map((item, i) => <li key={i} className="flex items-start" data-id="element-187">
              <div className="bg-amber-500/20 p-1 rounded-full mr-4 mt-1" data-id="element-188">
                <CheckIcon className="w-4 h-4 text-amber-500" data-id="element-189" />
              </div>
              <span className="text-lg text-cream-50" data-id="element-190">{item}</span>
            </li>)}
        </ul>

        <div className="mt-8 pt-6 border-t border-warm-700 text-center" data-id="element-191">
          <p className="text-cream-100 italic" data-id="element-192">
            Todo en español claro. Cero jerga. Cero drama.
          </p>
        </div>
      </div>
    </Section>;
}